import CountryComponent from '../../Components/Masters/Country/CountryComponent'

function CountryPage() {
    return (
        <CountryComponent/>
    )
}

export default CountryPage